import gql from 'graphql-tag';

export default gql`
  query sortBrandsBySKURelatedToCategory($filter: SortBrandsBySKURelatedToCategoryInput, $pagination: Pagination) {
    sortBrandsBySKURelatedToCategory(filter: $filter, pagination: $pagination) {
      totalPage
      totalResults
      data {
        key
        value {
          items {
            id
            slug
            name
            imageUrl
            status
            groupName
          }
        }
      }
    }
  }
`;
